import { BuilderConfig } from '@/types/builder';

import RoomStayBlogCustomerFAQs, { CustomerFAQsProps } from './roomstay-blog-customer-faqs';

export const RoomStayBlogCustomerFAQsBuilderConfig = {
    name: 'Customer FAQs',
    inputs: [
        {
            name: 'title',
            type: 'html',
            defaultValue: '',
        },
        {
            name: 'description',
            type: 'richText',
            defaultValue: '',
        },
        {
            name: 'faqs',
            type: 'list',
            subFields: [
                {
                    name: 'text',
                    type: 'html',
                    defaultValue: '',
                },
                {
                    name: 'description',
                    type: 'richText',
                    defaultValue: '',
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<CustomerFAQsProps> = {
    component: RoomStayBlogCustomerFAQs,
    config: RoomStayBlogCustomerFAQsBuilderConfig,
};

export default builderConfig;
